import { colors, typography } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const SectionInfoStyled = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.neutral[900]};
  margin-bottom: 2rem;
`;

export const TotalFilesLabelStyled = styled.p`
  ${typography.regular[16]}
  margin: 0;
`;

export const TitleStyled = styled.h3`
  ${typography.capsBold[18]}
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const FilesAmountStyled = styled.b`
  margin-left: 1rem;
`;
